<template>
  <v-text-field
    :style="{'width':width}"
    full-width
    outlined
    rounded
    dense
    :height="height"
    hide-details="auto"
    @input="onchange"
    :value="value"
    :disabled="disabled"
    :error-messages="errorsMsg"
    :class="size"
    :placeholder="placeholder"
    :maxlength="max"
    :type="type"
    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
  ></v-text-field>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    height: {
      type: [String],
      default() {
        return '32px';
      },
    },
    value: {
      type: [String, Number, Object],
    },
    disabled: {
      type: [Boolean],
    },
    errorsMsg: {
      type: [String, Array],
    },
    size: {
      type: [String],
      default() {
        return 'w-200';
      },
    },
    placeholder: {
      type: [String],
    },
    max: {
      type: [String, Number],
      default() {
        return 524288;
      },
    },
    type: {
      type: [String],
      default() {
        return 'text';
      },
    },
    width: {
      type: String,
    },
  },
  methods: {
    onchange(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-text-field.v-select .v-input__control .v-input__slot {
  input {
    line-height: initial;
  }
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px;
  background-color: $white;
  .v-input__append-inner {
    height: 100%;
    display: flex;
    align-items: center;
  }
}

::v-deep.FormInput__right .v-input__control .v-input__slot {
  input {
    text-align: end;
  }
}

::v-deep.v-input {
  display: inline-block !important;
}

/* 去除number input arrows */
/* Chrome, Safari, Edge, Opera */
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

/* 自訂input size */
@include phone-width() {
  .w-50 {
    width: 50px;
  }
  .w-100 {
    width: 100px;
  }

  .w-200 {
    width: 200px;
  }

  .w-300 {
    width: 300px;
  }

  .w-400 {
    width: 400px;
  }

  .w-500 {
    width: 500px;
  }
}
</style>
